module.exports = __webpack_public_path__ + "static/media/SecurityEllipse.bc47f3e3.svg";